import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Dialog, DialogContent
} from "@mui/material";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import { CepPorEndereco } from "app/types/CepPorEndereco";
import React from "react";
import { PaperArrastavel } from "../../../../dialog-arrastavel/PaperArrastavel";

const estilosModalSelecionarCep = require("../../../../../estilos/modalSelecionarCepCompartilhado.module.scss").default;

export type ModalSelecionarCepProps = {
    dados: PagedMessageResponse<CepPorEndereco>;
    open: boolean;
    onFecharModal: () => void;
    onEnderecoSelecionado: (endereco: CepPorEndereco) => void;
    onAlterarListaSelecionadaEndereco: (numeroIndexPagina?: number) => void
};

export const ModalSelecionarCep = (props: ModalSelecionarCepProps) => {

    const headerTabelaModalCep = () => {
        const mapHeader = ["CEP", "Logradouro", "Bairro", "Cidade", "UF", "Observacao"]

        return mapHeader.map((nome) => <div key={nome} className={`_table-cell ${estilosModalSelecionarCep.tableCellHeader}`}>{nome}</div>)
    }

    const bodyTabelaModalCep = (endereco: CepPorEndereco) => {
        const mapHeader = [endereco.Cep, endereco.Logradouro, endereco.Bairro, endereco.NomeCidade, endereco.SiglaUf, endereco.InfoComplementar]

        return mapHeader.map((nome, indice) => <div key={indice} className={`_table-cell ${estilosModalSelecionarCep.tableCellBody}`}>{nome}</div>)
    }

    return <>

        <Dialog
            maxWidth="xl"
            open={props.open}
            onClose={props.onFecharModal}
            PaperComponent={PaperArrastavel}
        >
            <div className="_px-4 _pt-4 _pb-2 _flex _justify-between _border-b-4 _border-[#f4f4f4]" data-arrastar-dialog>
                <h4 className="_font-bold">Selecione o CEP</h4>
                <div>
                    <a onClick={props.onFecharModal}>
                        <FontAwesomeIcon
                            icon={faTimes}
                            className={estilosModalSelecionarCep.exit}
                        />
                    </a>
                </div>
            </div>

            <DialogContent >

                <div className={`_table _w-full _border-collapse ${estilosModalSelecionarCep.tabelaModalCep}`}>
                    <div className="_table-header-group">
                        {headerTabelaModalCep()}
                    </div>

                    <div className="_table-row-group">
                        {props.dados?.Entities?.map((endereco) => (
                            <div key={endereco.Cep} className={`_table-row ${estilosModalSelecionarCep.linha}`} onClick={() => { props.onEnderecoSelecionado(endereco); props.onFecharModal()}}>
                                {bodyTabelaModalCep(endereco)}
                            </div>
                        ))}
                    </div>
                </div>

                {props.dados?.PageCount > 1 && (
                    <div className="_mt-2">
                        <Paginacao
                            paginaAtual={props.dados?.ActualPage}
                            totalPaginas={props.dados?.PageCount}
                            id="ModalSelecionarCep_Paginacao"
                            onAlterarListaSelecionada={props.onAlterarListaSelecionadaEndereco}
                        />
                    </div>
                )}

            </DialogContent>

        </Dialog>
    </>

}